import * as NavConstants from 'constants/NavConstants';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import {SearchParams} from 'search/SearchConstants';
import * as SearchPreferences from 'search/SearchPreferences';

import getDefaultAnalyticsSearchFilters from './getDefaultAnalyticsSearchFilters';

export function getDefaultAnalyticsSearchParams(): SearchParams {
  return {
    filters: getDefaultAnalyticsSearchFilters(),
    offset: 0,
    limit: getSelectedPageSize(),
    query: '',
    sorts: SearchPreferences.getAppliedSortsFromUserPreference(NavConstants.Section.ANALYTICS),
  };
}
